import { ROUTES } from 'app/core/router/paths';

/**
 * @description 流程步驟代碼
 */
export enum ProcessStepCodesEnum {
  /** 身份驗證 (Step-1) */
  Auth = '1',
  /** 輸入新電子信箱 (Step-2-1) */
  Setup = '2-1',
  /** 輸入新電子信箱 (Step-2-2) */
  SetupOTPAuth = '2-2'
}

/**
 * @description 流程步驟文字
 */
export enum ProcessStepTextEnum {
  /** 輸入原密碼 (Step-1) */
  Auth = '身份驗證',
  /** 輸入新電子信箱 (Step-2-1) */
  Setup = '輸入新電子信箱',
  /** 輸入新電子信箱 (Step-2-2) */
  SetupOTPAuth = '輸入新電子信箱'
}

/**
 * @description 流程路由對應步驟代碼
 */
export const ProcessRouteMatchesStep: Readonly<Record<string, ProcessStepCodesEnum>> = {
  /** 身份驗證 (Step-1) */
  [ROUTES.MEMBER__SETTINGS__EMAIL__AUTH]: ProcessStepCodesEnum.Auth,
  /** 輸入新電子信箱 (Step-2-1) */
  [ROUTES.MEMBER__SETTINGS__EMAIL__SETUP]: ProcessStepCodesEnum.Setup,
  /** 輸入新電子信箱 (Step-2-2) */
  [ROUTES.MEMBER__SETTINGS__EMAIL__SETUP__OTP_AUTH]: ProcessStepCodesEnum.SetupOTPAuth
};

/**
 * @description 流程步驟代碼對應路由
 */
export const ProcessStepMatchesRoute: Readonly<Record<ProcessStepCodesEnum, string>> = {
  /** 身份驗證 (Step-1) */
  [ProcessStepCodesEnum.Auth]: ROUTES.MEMBER__SETTINGS__EMAIL__AUTH,
  /** 輸入新電子信箱 (Step-2-1) */
  [ProcessStepCodesEnum.Setup]: ROUTES.MEMBER__SETTINGS__EMAIL__SETUP,
  /** 輸入新電子信箱 (Step-2-2) */
  [ProcessStepCodesEnum.SetupOTPAuth]: ROUTES.MEMBER__SETTINGS__EMAIL__SETUP__OTP_AUTH
};
